import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import style from "../../../scss/Dashboard.module.scss";
import { MOTIVOS_PROBLEMA } from "../../../utils/problemasMesa";
import MesaTarjetaComponent, { EtiquetaMotivo } from "./MesaTarjetaComponent";

// Todas las mesas con problemas (ver utils/problemasMesa): resumen por motivo
// y una tarjeta por mesa que lleva a su escrutinio.
const MesasProblemaComponent = ({ mesas, rutaTodas }) => {
  const conteoPorMotivo = Object.keys(MOTIVOS_PROBLEMA).map((clave) => ({
    clave,
    total: mesas.filter((mesa) => mesa.motivos.some((m) => m.clave === clave)).length,
  }));

  return (
    <section className={style.panel} aria-labelledby="titulo-problemas">
      <div className={style.cabecera}>
        <h2 id="titulo-problemas" className={style.corporacion}>
          Mesas con problemas{" "}
          <span className={`badge ${mesas.length ? "text-bg-danger" : "text-bg-success"} ${style.contador}`}>
            {mesas.length}
          </span>
        </h2>
        {mesas.length > 0 && (
          <Link to={rutaTodas} className={style.verTodas}>
            Ver en la lista de mesas <Icon icon="mdi:arrow-right" aria-hidden="true" />
          </Link>
        )}
      </div>

      {mesas.length === 0 ? (
        <p className={style.vacio}>
          <Icon icon="mdi:check-circle-outline" aria-hidden="true" /> No hay mesas con problemas.
        </p>
      ) : (
        <>
          <ul className={style.resumenMotivos}>
            {conteoPorMotivo.map(({ clave, total }) => (
              <li key={clave}>
                <EtiquetaMotivo clave={clave} />
                <strong>{total}</strong>
              </li>
            ))}
          </ul>

          <ul className={style.mesas}>
            {mesas.map((mesa) => (
              <li key={mesa.id}>
                <MesaTarjetaComponent mesa={mesa} />
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
};

export default MesasProblemaComponent;
